import React from 'react';
import PropTypes from 'prop-types';

const Socials = ({ url }) => {
  return (
    <div className="blog-socials-container">
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} rel="noopener noreferrer" target="_blank">
        <i className="fa-brands fa-facebook-f" />
      </a>
      <a href={`https://twitter.com/share?url=${url}`} rel="noopener noreferrer" target="_blank">
        <i className="fa-brands fa-twitter" />
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} rel="noopener noreferrer" target="_blank">
        <i className="fa-brands fa-linkedin-in" />
      </a>
      <a onClick={() => navigator.clipboard.writeText(url)}>
        <i className="fa-solid fa-copy" />
      </a>
    </div>
  );
};

Socials.propTypes = {
  url: PropTypes.string,
};

export default Socials;
